module.exports = require("@brightsec/node-libcurl");